var _desc, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Arrange-Number-Descending--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Arrange Number Descending Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.594 5.25c0.2955 0 0.588 -0.0582 0.861 -0.17127s0.5211 -0.27881 0.73 -0.48774c0.2089 -0.20893 0.3747 -0.45697 0.4877 -0.72995 0.1131 -0.27298 0.1713 -0.56557 0.1713 -0.86104s-0.0582 -0.58806 -0.1713 -0.86104c-0.113 -0.27298 -0.2788 -0.52102 -0.4877 -0.72995 -0.2089 -0.20893 -0.457 -0.37467 -0.73 -0.487739C17.182 0.808198 16.8895 0.75 16.594 0.75c-0.5967 0 -1.169 0.237053 -1.591 0.65901 -0.422 0.42196 -0.659 0.99425 -0.659 1.59099 0 0.59674 0.237 1.16903 0.659 1.59099 0.422 0.42196 0.9943 0.65901 1.591 0.65901Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.844 9.74995c0.7956 0 1.5587 -0.31607 2.1213 -0.87868 0.5626 -0.56261 0.8787 -1.32567 0.8787 -2.12132v-3.748",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.532 23.246h5.624",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.344 23.2481v-8.436c0.0002 -0.1059 -0.0295 -0.2098 -0.0858 -0.2995 -0.0563 -0.0898 -0.1368 -0.1619 -0.2322 -0.2079 -0.0954 -0.0459 -0.2019 -0.064 -0.3072 -0.0521 -0.1053 0.0119 -0.2051 0.0533 -0.2878 0.1195l-1.9 1.517",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.84399 4.5v15",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.84399 16.5 3 3 3 -3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberSort);
export default __webpack_public_path__ + "static/media/numberSort.d6feedcb840582c21d68d8695fc42981.svg";
export { ForwardRef as ReactComponent };